import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {RespinSpinUIAct} from '@gongxigames/framework/slotV2/ui/acts/RespinSpinUIAct';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {AutoplayCheckAfterFeatureUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayCheckAfterFeatureUIAct';

export class RespinSpinUIState extends UIState {
    public static readonly ID = 'RespinSpinUIState';

    public setAct(): void {
        this.act = sequence([
            RespinSpinUIAct,
            AutoplayCheckAfterFeatureUIAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.feature_type.value?.type === 'respins';
    }
}